import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="aspect-[16/9] overflow-hidden bg-background-100">
          <img
            src={article.imageUrl}
            alt={article.title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            title={`${article.title} - 亚洲免费在线`}
          />
        </div>
      </Link>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <Link
            to={`/category/${article.category}`}
            className="text-xs font-medium px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 hover:bg-secondary-200 transition-colors whitespace-nowrap"
          >
            {article.categoryName}
          </Link>
          <span className="text-xs text-foreground-500">{article.date}</span>
          <span className="text-xs text-foreground-500">&middot; {article.readTime}</span>
        </div>
        <Link to={`/article/${article.slug}`}>
          <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors font-heading">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {article.description}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {article.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded">
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}